import React, { useState } from 'react';
import { 
  Box, Typography, Grid, Tabs, Tab, Button 
} from '@mui/material';

import VerPaletes from './verpaletes';
import CriarExpedicao from './criarexpedicao';
import ExpedicoesCriadas from './expedicoescriadas';
import ConsultarExpedicoes from './consultarexpedicoes';
import ClientesTab from './ClientesTab';
import ManifestosImp from './manifestosimp.js';
import Orcamentos from './orcamentos';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

const AlterarDefinicoesServidor = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [openExpedicao, setOpenExpedicao] = useState(false);
  const [openManifestos, setOpenManifestos] = useState(false);
  const [openOrcamentos, setOpenOrcamentos] = useState(false);
  const [expedicoesReloadTrigger, setExpedicoesReloadTrigger] = useState(0);
  const [verPaletesReloadTrigger, setVerPaletesReloadTrigger] = useState(0);

  const apiBaseURL = 'https://plasticemployers.duckdns.org/api';

  // Troca de abas
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const handleReloadVerPaletes = () => {
  setVerPaletesReloadTrigger(prev => prev + 1);
};

  const handleExpedicaoCreated = () => {
    setExpedicoesReloadTrigger(prev => prev + 1);
  };
  // Abertura/fecho modais expedição
  const handleOpenExpedicao = () => setOpenExpedicao(true);
  const handleCloseExpedicao = () => setOpenExpedicao(false);

  // Abertura/fecho modal manifestos
  const handleOpenManifestos = () => setOpenManifestos(true);
  const handleCloseManifestos = () => setOpenManifestos(false);

  // Abertura/fecho modal orçamentos
  const handleOpenOrcamentos = () => setOpenOrcamentos(true);
  const handleCloseOrcamentos = () => setOpenOrcamentos(false);

  return (
    <Box p={2}>
      <Typography variant="h1">Dachser Encomendas</Typography>

      {/* Abas principais */}
      <Tabs value={currentTab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Encomendas" />
        <Tab label="Moradas dos Clientes" />
        {/* <Tab label="Moradas" /> */}
      </Tabs>

      {/* Área superior: tabela de consulta + botões de acção */}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8}>
          
        </Grid>

        {/* Botões de acção */}
        <Grid item xs={1}>
          <Button variant="contained" color="primary" fullWidth onClick={handleOpenExpedicao}>
            Criar Expedição
          </Button>
        </Grid>
        <Grid item xs={2}>
          <Button variant="contained" color="success" fullWidth onClick={handleOpenManifestos}>
            Imprimir Manifestos
          </Button>
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" color="secondary" fullWidth onClick={handleOpenOrcamentos}>
            Orçamentos
          </Button>
        </Grid>
      </Grid>

      {/* Modais */}
      <CriarExpedicao
        open={openExpedicao}
        onClose={handleCloseExpedicao}
        apiBaseURL={apiBaseURL}
        onSubmit={handleExpedicaoCreated}      
      />

      <ManifestosImp
        open={openManifestos}
        onClose={handleCloseManifestos}
        apiBaseURL={apiBaseURL}
      />

      <Orcamentos
        open={openOrcamentos}
        onClose={handleCloseOrcamentos}
        apiBaseURL={apiBaseURL}
      />

      {/* Conteúdo das abas */}
      <TabPanel value={currentTab} index={0}>
        <Grid container spacing={1}>
        <Grid item xs={5}>
           <ExpedicoesCriadas
              apiBaseURL={apiBaseURL}
              reload={expedicoesReloadTrigger}
              onVerPaletesReload={handleReloadVerPaletes}
            />
          </Grid>
          
          <Grid item xs={5}>
            <VerPaletes apiBaseURL={apiBaseURL} reload={verPaletesReloadTrigger} />
          </Grid>
        </Grid>
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <ClientesTab apiBaseURL={apiBaseURL} />
      </TabPanel>
      {/*
      <TabPanel value={currentTab} index={2}>
        <Typography variant="h6">Moradas</Typography>
        <Typography variant="body1">Em desenvolvimento...</Typography>
      </TabPanel>
      */}
    </Box>
  );
};

export default AlterarDefinicoesServidor;
